(()=> {
    class CollectionDrawer extends HTMLElement {
    constructor() {
      super();
      this.backdrop = this.querySelector(".collection-drawer__backdrop");
      this.drawerPanel = null;
      this.closeBtn = this.querySelector(".collection-drawer__close");
      this.toggleBtn = document.querySelector(".collection-drawer__button-open");
      this.activeFilters = document.querySelector("#active-filters-mob");

     // console.log('[Drawer Debug] Constructor - toggleBtn element:', this.toggleBtn);
    //  console.log('[Drawer Debug] Constructor - toggleBtn aria-expanded:', this.toggleBtn?.getAttribute("aria-expanded"));
    }

    connectedCallback() {
     // console.log('[Drawer Debug] connectedCallback - Initializing drawer');
     // console.log('[Drawer Debug] toggleBtn found:', !!this.toggleBtn);
     // console.log('[Drawer Debug] backdrop found:', !!this.backdrop);
    //  console.log('[Drawer Debug] closeBtn found:', !!this.closeBtn);

      // Check if there are multiple buttons (this could be the issue)
      const allButtons = document.querySelectorAll(".collection-drawer__button-open");
     // console.log('[Drawer Debug] Total buttons found:', allButtons.length);
      allButtons.forEach((btn, index) => {
     //   console.log(`[Drawer Debug] Button ${index + 1} aria-expanded:`, btn.getAttribute("aria-expanded"));
      });

      // Note: Click event listener for toggleBtn is now handled in reinitDrawer() method
      // to ensure it works after AJAX updates

      this.backdrop?.addEventListener("click", () => this.close());
      this.closeBtn?.addEventListener("click", () => this.close());
      this.activeFilters?.addEventListener("click", () => this.close());

      // Initialize mutation observer to watch for drawer state changes
      this.initMutationObserver();
    }

    open() {
      /*
      console.log('[Drawer Debug] open() called - Current drawer state:', {
        dataVisible: this.getAttribute("data-visible"),
        hasActiveClass: this.classList.contains("active"),
        ariaExpanded: this.toggleBtn?.getAttribute("aria-expanded")
      });*/

      //console.log('[Drawer Debug] Setting data-visible="true"');
      this.setAttribute("data-visible", "true");
     // console.log('[Drawer Debug] Setting aria-expanded="true" on toggleBtn');
      this.toggleBtn?.setAttribute("aria-expanded", "true");
     // console.log('[Drawer Debug] Adding body-no-scroll class');
      document.documentElement.classList.add("body-no-scroll");
      setTimeout(() => {
       //  console.log('[Drawer Debug] Adding active class to drawer');
         this.classList.add("active");
         /*
         console.log('[Drawer Debug] open() completed - Final state:', {
           dataVisible: this.getAttribute("data-visible"),
           hasActiveClass: this.classList.contains("active"),
           ariaExpanded: this.toggleBtn?.getAttribute("aria-expanded")
         });*/
      }, 300);
    }

    close() {
     // console.log('[Drawer Debug] close() called');
    //  console.log('[Drawer Debug] Removing active class from drawer');
      this.classList.remove("active");

      // Always find the button fresh from the DOM
      const domBtn = document.querySelector(".collection-drawer__button-open");
    //  console.log('[Drawer Debug] Found DOM button for close():', !!domBtn);

      if (domBtn) {
      //  console.log('[Drawer Debug] Current aria-expanded before close:', domBtn.getAttribute("aria-expanded"));

        // Set the attribute multiple ways to ensure it sticks
        domBtn.setAttribute("aria-expanded", "false");
        domBtn["aria-expanded"] = "false";

       // console.log('[Drawer Debug] After close() - aria-expanded value:', domBtn.getAttribute("aria-expanded"));
      } else {
       // console.log('[Drawer Debug] ERROR: Could not find button in close()!');
      }

     // console.log('[Drawer Debug] Removing body-no-scroll class');
      document.documentElement.classList.remove("body-no-scroll");
      this.observeBodyScroll();
      setTimeout(() => {
       // console.log('[Drawer Debug] Setting data-visible="false"');
        this.setAttribute("data-visible", "false");

        // After drawer is fully closed, check if button is still functional
        setTimeout(() => {
          console.log('[Drawer Debug] Post-close check:', {
            drawerDataVisible: this.getAttribute("data-visible"),
            drawerHasActiveClass: this.classList.contains("active"),
            buttonAriaExpanded: this.toggleBtn?.getAttribute("aria-expanded"),
            buttonExists: !!this.toggleBtn,
            buttonDisabled: this.toggleBtn?.disabled
          });
        }, 100);
      }, 300);
    }
    observeBodyScroll() {
    //  console.log('[Drawer Debug] observeBodyScroll() called');
      const html = document.querySelector("html");
      const hasBodyNoScroll = html.classList.contains("body-no-scroll");
     // console.log('[Drawer Debug] HTML has body-no-scroll class:', hasBodyNoScroll);

      if (hasBodyNoScroll) {
      //  console.log('[Drawer Debug] Setting aria-expanded="true" (body has no-scroll)');
        this.toggleBtn?.setAttribute("aria-expanded", "true");
      } else {
       // console.log('[Drawer Debug] Setting aria-expanded="false" (body does not have no-scroll)');
        this.toggleBtn?.setAttribute("aria-expanded", "false");
      }

     // console.log('[Drawer Debug] Current aria-expanded value:', this.toggleBtn?.getAttribute("aria-expanded"));
    }

    initMutationObserver() {
     // console.log('[Drawer Debug] initMutationObserver() called');

      // Set up click event listener for the toggle button
      if (this.toggleBtn) {
      //  console.log('[Drawer Debug] Setting up click event listener in initMutationObserver');
        this.toggleBtn.addEventListener("click", (event) => {
          console.log('[Drawer Debug] Toggle button clicked from initMutationObserver!', {
            event,
            button: this.toggleBtn,
            currentAriaExpanded: this.toggleBtn?.getAttribute("aria-expanded"),
            drawerDataVisible: this.getAttribute("data-visible")
          });
          event.preventDefault();
          event.stopPropagation();
          this.open();
        });
      } else {
        // console.log('[Drawer Debug] ERROR: toggleBtn not found in initMutationObserver');
      }

      // Observe changes to the drawer's data-visible attribute and class
      const observer = new MutationObserver((mutations) => {
        //console.log('[Drawer Debug] MutationObserver callback triggered');
        //console.log('[Drawer Debug] Number of mutations:', mutations.length);

        let shouldUpdateAria = false;

        mutations.forEach((mutation, index) => {
          console.log(`[Drawer Debug] Mutation ${index + 1}:`, {
            type: mutation.type,
            attributeName: mutation.attributeName,
            target: mutation.target,
            targetTagName: mutation.target.tagName,
            targetId: mutation.target.id,
            targetClassName: mutation.target.className
          });

          // Check if the drawer itself is being modified
          if (mutation.target === this) {
          //  console.log('[Drawer Debug] Mutation target is the drawer element');

            // If data-visible attribute changes to "false"
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-visible') {
              const currentDataVisible = this.getAttribute('data-visible');
              console.log('[Drawer Debug] data-visible changed to:', currentDataVisible);
              if (currentDataVisible === 'false') {
                console.log('[Drawer Debug] Setting shouldUpdateAria = true (data-visible is false)');
                shouldUpdateAria = true;
              }
            }
            // If the 'active' class is removed
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const hasActiveClass = this.classList.contains('active');
              console.log('[Drawer Debug] Drawer has active class:', hasActiveClass);
              if (!hasActiveClass) {
                console.log('[Drawer Debug] Setting shouldUpdateAria = true (active class removed)');
                shouldUpdateAria = true;
              }
            }
          }

          // Also check for body-no-scroll class removal on html element
          if (mutation.target === document.documentElement && mutation.attributeName === 'class') {
            console.log('[Drawer Debug] Mutation target is documentElement');
            const hasBodyNoScroll = document.documentElement.classList.contains('body-no-scroll');
            console.log('[Drawer Debug] HTML has body-no-scroll class:', hasBodyNoScroll);
            if (!hasBodyNoScroll) {
              console.log('[Drawer Debug] Setting shouldUpdateAria = true (body-no-scroll removed)');
              shouldUpdateAria = true;
            }
          }
        });

        console.log('[Drawer Debug] Final shouldUpdateAria value:', shouldUpdateAria);

        if (shouldUpdateAria) {
          console.log('[Drawer Debug] Updating aria-expanded to false via mutation observer');

          // Always find the button fresh from the DOM to ensure we have the right reference
          const domBtn = document.querySelector(".collection-drawer__button-open");

          if (domBtn) {
            console.log('[Drawer Debug] Found DOM button, current aria-expanded:', domBtn.getAttribute("aria-expanded"));

            // Set the attribute multiple ways to ensure it sticks
            domBtn.setAttribute("aria-expanded", "false");
            domBtn["aria-expanded"] = "false";

            console.log('[Drawer Debug] After setting - aria-expanded value:', domBtn.getAttribute("aria-expanded"));

            // Check if it gets overridden after a short delay
            setTimeout(() => {
              const afterDelay = domBtn.getAttribute("aria-expanded");
              console.log('[Drawer Debug] After 100ms delay - aria-expanded:', afterDelay);

              // If it's still true, force it again with multiple methods
              if (afterDelay === "true") {
                console.log('[Drawer Debug] Attribute was overridden, using aggressive methods');

                // Method 1: Standard setAttribute
                domBtn.setAttribute("aria-expanded", "false");

                // Method 2: Direct property assignment
                domBtn["aria-expanded"] = "false";

                // Method 3: Try to override any potential setter
                Object.defineProperty(domBtn, "aria-expanded", {
                  value: "false",
                  writable: false,
                  configurable: true
                });

                console.log('[Drawer Debug] After aggressive methods - aria-expanded:', domBtn.getAttribute("aria-expanded"));

                // Set up a watcher to catch any future changes
                let watcherTimeout = setTimeout(() => {
                  const finalCheck = domBtn.getAttribute("aria-expanded");
                  console.log('[Drawer Debug] Final check after aggressive methods:', finalCheck);

                  if (finalCheck === "true") {
                    console.log('[Drawer Debug] Still overridden - this might be caused by another script');
                  }
                }, 200);

                // Clean up the watcher
                setTimeout(() => clearTimeout(watcherTimeout), 500);
              }
            }, 100);
          } else {
            console.log('[Drawer Debug] ERROR: Could not find DOM button!');
          }
        } else {
          console.log('[Drawer Debug] Not updating aria-expanded (shouldUpdateAria is false)');
        }
      });

      // Observe the drawer element for attribute and class changes
      console.log('[Drawer Debug] Setting up observer for drawer element (data-visible, class)');
      observer.observe(this, {
        attributes: true,
        attributeFilter: ['data-visible', 'class']
      });

      // Also observe the html element for body-no-scroll class changes
      console.log('[Drawer Debug] Setting up observer for html element (class changes)');
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
      });

      console.log('[Drawer Debug] MutationObserver setup complete');

      // Store observer reference for cleanup if needed
      this._drawerObserver = observer;
    }

    disconnectedCallback() {
      // Clean up the mutation observer when the element is removed
      if (this._drawerObserver) {
        this._drawerObserver.disconnect();
        this._drawerObserver = null;
      }
    }
  }

  customElements.define("collection-drawer", CollectionDrawer);
})();